<script lang="ts" setup>
import { cn } from '@/lib/utils'
import { Minus } from 'lucide-vue-next'
import { HTMLAttributes, inject } from 'vue'
import { Button } from '../button'

const emit = defineEmits<{
    (e: 'decrement'): void
}>()

const props = defineProps<{
    class?: HTMLAttributes['class']
}>()

const min = inject<number>('min')
const counter = inject<number>('counter')
</script>

<template>
    <Button
        v-bind="$attrs"
        type="button"
        :disabled="min === counter"
        size="icon"
        variant="outline"
        :class="cn('', props.class)"
        @click="emit('decrement')"
    >
        <Minus class="size-4" />
    </Button>
</template>
